import React, { useEffect, useState } from "react";
import { Button, Typography, Input, message, Select, Form, Image } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { authSVC, categorySVC } from "../../services";
import { Option } from "antd/es/mentions";
import { useB2BContext } from "../../context/ContextB2B";
import { useNavigate } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import "./NewsFlash.scss";

const { Text } = Typography;

function NewsFlash() {
  const [form] = Form.useForm();
  const [newsFlashData, setNewsFlashData] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [newsId, setNewsId] = useState<any>();

  const onFinish = (value: any) => {
    authSVC
      .AddNewsFlash({
        title: value.title,
        type: value.type,
        link: value.link,
      })
      .then((res: any) => {
        message.success("Added Successfully");
        form.resetFields();
        authSVC
          .getNewsFlash()
          .then((res: any) => {
            setNewsFlashData(res.data.data);
          })
          .catch((err: any) => {
            message.error(err.response?.data?.error);
          });
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  };

  const onFinishEdit = (value: any) => {
    authSVC
      .UpdateNewsFlash(
        {
          title: value.title,
          type: value.type,
          link: value.link,
        },
        newsId
      )
      .then((res: any) => {
        message.success("Update Successfully");
        form.resetFields();
        setNewsId(false);
        setIsEdit(false);
        authSVC
          .getNewsFlash()
          .then((res: any) => {
            setNewsFlashData(res.data.data);
            console.log(res.data.data, "HHHH");
          })
          .catch((err: any) => {
            message.error(err.response?.data?.error);
          });
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  };

  useEffect(() => {
    authSVC
      .getNewsFlash()
      .then((res: any) => {
        setNewsFlashData(res.data.data);
        console.log(res.data.data, "HHHH");
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  }, []);

  const NewsEdit = (data: any) => {
    setIsEdit(true);
    setNewsId(data._id);
    form.setFieldsValue({
      title: data?.title,
      type: data?.type,
      link: data?.link,
    });
  };

  const NewsCancelEdit = () => {
    setIsEdit(false);
    setNewsId(false);
    form.resetFields();
  };

  const NewsDelete = (data: any) => {
    authSVC
      .DeleteNewsFlash(data._id)
      .then((res: any) => {
        message.success("Deleted Successfully");
        setNewsFlashData((prev: any) =>
          prev?.filter((item: any) => item._id !== data._id)
        );
        authSVC
          .getNewsFlash()
          .then((res: any) => {
            setNewsFlashData(res.data.data);
          })
          .catch((err: any) => {
            message.error(err.response?.data?.error);
          });
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
      });
  };

  return (
    <div className="contentBox news_flash_page">
      <div className="info">
        <Text className="title24">News Flash</Text>
      </div>
      <div className="news_flash_layout">
        <div className="news_flash_form_card">
          {isEdit ? (
            <>
              <h1>Edit News Flash</h1>
              <Form
                name="normal_login"
                initialValues={{ remember: true }}
                onFinish={onFinishEdit}
                form={form}
              >
                <Form.Item
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Title!",
                    },
                  ]}
                >
                  <TextArea
                    name="title"
                    className="input"
                    placeholder="Please Enter Title"
                    // maxLength={6}
                  />
                </Form.Item>
                <Form.Item
                  name="type"
                  rules={[
                    {
                      required: true,
                      message: "Please select type!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", borderRadius: "24px" }}
                    placeholder="Select type"
                    optionFilterProp="children"
                  >
                    <option value="link">Link</option>
                    <option value="video">Video</option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="link"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Link!",
                    },
                  ]}
                >
                  <TextArea
                    name="link"
                    className="input"
                    placeholder="Please Enter Link"
                    // maxLength={6}
                  />
                </Form.Item>
                <div className="news_flash_form_card__actions">
                  <Button
                    className="button_add_emp"
                    htmlType="submit"
                    icon={<Image src="/img/new/add.svg" preview={false} alt="" />}
                  >
                    Update
                  </Button>
                  <Button
                    className="table_pill_btn table_pill_btn--view"
                    onClick={NewsCancelEdit}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </>
          ) : (
            <>
              <h1>Add News Flash</h1>
              <Form
                name="normal_login"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                form={form}
              >
                <Form.Item
                  name="title"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Title!",
                    },
                  ]}
                >
                  <TextArea
                    name="title"
                    className="input"
                    placeholder="Please enter title"
                  />
                </Form.Item>
                <Form.Item
                  name={"type"}
                  rules={[
                    {
                      required: true,
                      message: "Please select type!",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "100%", borderRadius: "24px" }}
                    placeholder="Select type"
                    optionFilterProp="children"
                  >
                    <option value="link">Link</option>
                    <option value="video">Video</option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="link"
                  rules={[
                    {
                      required: true,
                      message: "Please enter link!",
                    },
                  ]}
                >
                  <TextArea
                    name="link"
                    className="input"
                    placeholder="Please Enter Link"
                  />
                </Form.Item>
                <div className="news_flash_form_card__actions">
                  <Button
                    className="button_add_emp"
                    htmlType="submit"
                    icon={<Image src="/img/new/add.svg" preview={false} alt="" />}
                  >
                    Add
                  </Button>
                </div>
              </Form>
            </>
          )}
        </div>
        <div className="news_flash_list">
          {newsFlashData && newsFlashData.length > 0 ? (
            newsFlashData.map((data: any) => (
              <div className="news_flash_item" key={data._id}>
                <div className="news_flash_item__top">
                  <span className="news_flash_item__type">{data.type}</span>
                </div>
                <h3>{data.title}</h3>
                <p>
                  <strong>Link : </strong>
                  {data.link}
                </p>
                <div className="news_flash_item__actions">
                  <Button
                    className="table_pill_btn table_pill_btn--view"
                    icon={<EditOutlined />}
                    onClick={() => NewsEdit(data)}
                  >
                    Edit
                  </Button>
                  <Button
                    className="table_pill_btn table_pill_btn--danger"
                    icon={<DeleteOutlined />}
                    onClick={() => NewsDelete(data)}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            ))
          ) : (
            <div className="news_flash_empty">No news flash items yet.</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewsFlash;
